exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[name=text-field]:disabled{background-color:#e6e6e6}", ""]);

// exports
